<template>
	<div>
		<div class="an-home">
			<div data-v-486d5814="" data-v-30babe2d="" class="my-header">
				<div data-v-486d5814=""
					class="header-row van-row van-row--flex van-row--align-center van-row--justify-space-between">
					<div data-v-486d5814="" class="van-col van-col--8">
						<div data-v-459e9abf="" class="van-dropdown-menu">
							<div class="van-dropdown-menu__bar" @click="lang_open()">
								<div role="button" tabindex="0" class="van-dropdown-menu__item"><span
										class="van-dropdown-menu__title" style="">
										<div class="van-ellipsis" id="lang_text">{{xz_lang}}</div>
									</span></div>
							</div>
							<div data-v-459e9abf="">
								<div class="van-dropdown-item van-dropdown-item--down" style="top: 48.9531px;;"
									id="lang_div" v-show="lang_div">
									<div class="van-overlay"
										style="z-index: 2003; position: absolute; animation-duration: 0.2s; display: ;"
										@click="lang_open()">
									</div>
									<div class="van-popup van-popup--top van-dropdown-item__content"
										style="transition-duration: 0.2s; z-index: 2004; display: ;">

										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option" style=""
											@click="change('en','English')">
											<div class="van-cell__title"><span>English</span></div>
										</div>

										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('tu','Türkçe')">
												<span>Türkçe</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('po','Português')">
												<span>Português</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('al','عربي')">
												<span>عربي</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('de','Deutsch')">
												<span>Deutsch</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('xi','español')">
												<span>español</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('yi','Italiano')">
												<span>Italiano</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('el','Русский')">
												<span>Русский</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option">
											<div class="van-cell__title" @click="change('ja','日本')">
												<span>日本</span>
											</div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option"
											@click="change('zh','简体中文')">
											<div class="van-cell__title"><span>简体中文</span></div>
										</div>
										<div role="button" tabindex="0"
											class="van-cell van-cell--clickable van-dropdown-item__option "
											@click="change('fa','繁体中文')">
											<div class="van-cell__title"><span>繁体中文</span></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div data-v-486d5814="" class="van-col van-col--8">
						<div data-v-486d5814="" class="flex align-center justify-center">
							<h2 data-v-486d5814="" class="plat-name">Pool</h2>
						</div>
					</div>
					<div data-v-486d5814="" class="van-col van-col--8" style="text-align: right; padding-right: 10px;">
						<button data-v-486d5814="" disabled="disabled"
							class="van-button van-button--default van-button--mini van-button--plain van-button--disabled van-button--hairline van-hairline--surround"
							style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
							<div data-v-486d5814="" class="van-button__content"><img :src="bi_img" style="width: 20px;height: 20px;"/><span data-v-486d5814=""
									class="van-button__text"
									style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:10px;margin-left: 10px;">{{selectedAccount}}</span>
							</div>
						</button>
					</div>
				</div>
			</div>
			<div data-v-3e39609a="" class="ypage-box">
				<div data-v-3e39609a="" class="my_pool_container">
					<div data-v-3e39609a="" class="min-title">{{$t('我的矿池')}}</div>
					<div data-v-3e39609a="" class="bg_cover"></div>
					<div data-v-3e39609a="" class="my_pool_content">
						<div data-v-3e39609a="" class="img_top"><img data-v-3e39609a=""
								src="../../public/img/img_ser.f03b1edc_f03b1edc63f6bb73bb5fa3252c0f34c3.png"
								class="img_cover "></div>
						<div data-v-3e39609a="" class="balance flex align-center justify-between"><img
								data-v-3e39609a="" :src="bi_img"
								class="icon">
							<span data-v-3e39609a=""
								class="ff">{{zhiya_status == 1 ? user_data.zhiya_zong_shouyi : user_data.zong_shouyi}}
								{{type}}</span>
						</div>
						<div data-v-3e39609a="" class="sub_title ff_InterMedium">{{$t('总产量')}}</div>
						<div data-v-3e39609a="" class="value_container">
							<div data-v-3e39609a="" class="value_content flex-direction">
								<div data-v-3e39609a="" class="value_item flex align-center justify-between">
									<div data-v-3e39609a="" class="name ff_InterSemiBold">{{$t('总挖矿金额')}}
									</div>
									<div data-v-3e39609a="" class="value ff"><span data-v-3e39609a=""
											id="zong_u">{{user_data.zong_u}}

										</span> USDT
									</div>
								</div>
								<div data-v-3e39609a="" class="value_item flex align-center justify-between">
									<div data-v-3e39609a="" class="name ff_InterSemiBold">{{$t('可更换')}}({{type}})
									</div>
									<div data-v-3e39609a="" class="value ff"><span id="dtx">{{user_data.dtx}}</span>
										{{type}}
									</div>
								</div>
								<div data-v-3e39609a="" class="value_item flex align-center justify-between">
									<div data-v-3e39609a="" class="name ff_InterSemiBold">{{$t('收益率')}}
									</div>
									<div data-v-3e39609a="" class="value ff">{{user_level.val}}% </div>
								</div>
								<div data-v-3e39609a="" class="value_item flex align-center justify-between">
									<div data-v-3e39609a="" class="name ff_InterSemiBold">{{$t('币池名称')}}
									</div>
									<div data-v-3e39609a="" class="value ff">{{type}} </div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div data-v-3e39609a="" class="divider_container">
					<div data-v-3e39609a="" class="divider">
						<div data-v-3e39609a="" class="center_icon"><img data-v-3e39609a=""
								src="../../public/img/arrow-bottom.054eeb35_054eeb35f3c09dbf6ffdfb7a6ec4e5bd.svg"
								class="icon_arrow"></div>
					</div>
				</div>
				<div data-v-3e39609a="" class="record_container tl" v-show="putong_syl">
					<div data-v-3e39609a="" class="record_content">
						<div data-v-3e39609a="" class="block_title"><span data-v-3e39609a=""
								class="left_icon blue"></span> <span>{{$t('普通矿池收益率')}}</span>
						</div>
						<div data-v-3e39609a=""
							class="tb-header van-row van-row--flex van-row--align-center van-row--justify-space-between">
							<div data-v-3e39609a="" class="van-col van-col--8"
								style="margin-left: 20px; padding-right: 5px;">{{$t('最低金额')}}</div>
							<div data-v-3e39609a="" class="van-col van-col--8" style="padding-left: 5px;">{{$t('收益率/24小时')}}
							</div>
						</div>

						<div style="width:90%;height:30px;margin:0 auto;" v-for="item in level_data" :key="item">
							<div
								style="width:50%;height:100%;float:left;text-align:left;line-height:30px;font-size:14px;">
								{{item.key}}
							</div>

							<div
								style="width:40%;height:100%;float:left;text-align:right;line-height:30px;font-size:14px;padding-right:20px;">
								{{item.val}}%
							</div>
						</div>

					</div>
				</div>


				<div data-v-3e39609a="" class="record_container tl" v-show="gaoji_syl">
					<div data-v-3e39609a="" class="record_content">
						<div data-v-3e39609a="" class="block_title"><span data-v-3e39609a=""
								class="left_icon blue"></span> <span>{{$t('高级矿池收益率')}}</span>
						</div>
						<div data-v-3e39609a=""
							class="tb-header van-row van-row--flex van-row--align-center van-row--justify-space-between">
							<div data-v-3e39609a="" class="van-col van-col--8"
								style="margin-left: 20px; padding-right: 5px;">{{$t('最低金额')}}</div>
							<div data-v-3e39609a="" class="van-col van-col--8" style="padding-left: 5px;">{{$t('收益率/24小时')}}
							</div>
						</div>

						<div style="width:90%;height:30px;margin:0 auto;" v-for="item in level_data_gaoji" :key="item">
							<div
								style="width:50%;height:100%;float:left;text-align:left;line-height:30px;font-size:14px;">
								{{item.key}}
							</div>

							<div
								style="width:40%;height:100%;float:left;text-align:right;line-height:30px;font-size:14px;padding-right:20px;">
								{{item.val}}%
							</div>
						</div>

					</div>
				</div>



				<div data-v-3e39609a="" class="record_container tl">
					<div data-v-3e39609a="" class="record_content">
						<div data-v-3e39609a="" class="block_title"><span data-v-3e39609a=""
								class="left_icon blue"></span> <span>{{$t('挖矿记录')}}</span>
						</div>
						<div data-v-3e39609a="" class="record_list" style="padding: 0px;">
							<div data-v-3e39609a=""
								class="tb-header van-row van-row--flex van-row--align-center van-row--justify-space-between"
								style="border-left: none; border-right: none;">
								<div data-v-3e39609a="" class="van-col van-col--8" style="text-align: center;">{{$t('币种')}}

								</div>
								<div data-v-3e39609a="" class="van-col van-col--" style="text-align: center;">{{$t('金额')}}
								</div>
								<div data-v-3e39609a="" class="van-col van-col--8" style="text-align: center;">{{$t('时间')}}

								</div>
							</div>
							<div data-v-4f0d2356="" data-v-3e39609a="">
								<div data-v-4f0d2356="" class="no-data" style="min-height: 200px;">
									<div style="width:100%;height:30px;" v-for="item in shouyi_data" :key="item">
										<div data-v-3e39609a="" class="van-col van-col--8" style="text-align: center;">
											{{type}}
										</div>
										<div data-v-3e39609a="" class="van-col van-col--8" style="text-align: center;">
											{{item.sy_money}}
										</div>

										<div data-v-3e39609a="" class="van-col van-col--8" style="text-align: center;">
											{{item.addtime}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div data-v-2120af5d="" data-v-30babe2d="">
				<div data-v-2120af5d="" class="van-tabbar__placeholder" style="height: 50px;">
					<div class="van-tabbar van-tabbar--fixed">
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-home-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('首页')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item van-tabbar-item--active">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-gem"></i></div>
							<div class="van-tabbar-item__text">{{$t('我的矿池')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('exchange')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-paid"></i></div>
							<div class="van-tabbar-item__text">{{$t('提取')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('team')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-friends-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('推荐')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('account')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-user-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('账户')}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import Web3 from 'web3'
	import axios from 'axios'
	import {
		ethers
	} from 'ethers';
	import {
		useI18n
	} from 'vue-i18n'

	import domain from '../../public/domain';

	import layer from "layui-layer";
	export default {
		name: 'App',
		data() {
			return {
				selectedAccount: '',
				address: '',
				lang_div: false,
				xz_lang: 'English',
				level_data: [],
				level_data_gaoji: [],
				putong_syl: true,
				gaoji_syl: false,
				shouyi_data: [],
				type: 'ETH',
				user_level: [],
				user_data: [],
				zhiya_status: 0,
				bi_img: '../../img/eth.png',
			}
		},

		methods: {
			tz(url) {
				window.location.href = '/#' + url
			},
			change(type, name) {

				console.log(this.$i18n.locale)
				this.$i18n.locale = type
				this.lang_div = false
				this.xz_lang = name
				
				sessionStorage.setItem("lang_type", type);
			},
			lang_open() {
				if (this.lang_div == true) {
					this.lang_div = false
				} else {
					this.lang_div = true
				}
			},
			async wakeUpWallet() {

				this.bi_img = sessionStorage.getItem('bi_img');
				var address = sessionStorage.getItem("address");
				if (!address) {
					if (window.ethereum) {
						window.ethereum.enable().then((res) => {
							var address = res[0];
							console.log(address)
							this.selectedAccount = address.substr(0, 4) + "..." + address.substr(-4);
							this.address = address;

							sessionStorage.setItem("selectedAccount", this.selectedAccount);
							sessionStorage.setItem("address", this.address);
						})
					} else {
						// 		const web3 = new Web3(window.ethereum)
						await window.ethereum.request({
							method: 'eth_requestAccounts'
						});
						this.web3 = await new Web3(window.ethereum);
						this.connected = true;
						console.log("已连接钱包");
						alert("请安装钱包")
					}
				} else {
					this.selectedAccount = sessionStorage.getItem("selectedAccount");
					this.address = sessionStorage.getItem("address");
				}

				this.type = sessionStorage.getItem('bi_type');
				
				
				await window.ethereum.on('chainChanged', (chainId) => {
					// 正确处理链更改之后的业务流程可能很复杂。官方建议链更改只有重新加载页面
					console.log("chainId", chainId)
					window.location.reload();
				});

			},

			level_list() {

				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/level_data"
					})
					.then(function(response) {
						if (response.data.code == 0) {
							im.level_data = response.data.data;
						}
					})
					.catch(function(error) {
						console.log(error);
					});


			},
			level_list_gaoji() {

				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/level_data_gaoji"
					})
					.then(function(response) {
						if (response.data.code == 0) {
							im.level_data_gaoji = response.data.data;
						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			get_zhiya_status() {

				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/zhiya_status?address=" + address + "&type=" + newtype
					})
					.then(function(response) {
						if (response.data.code == 0) {
							if (response.data.data == 1) {
								im.zhiya_status = 1
								im.putong_syl = false
								im.gaoji_syl = true
							} else {
								im.zhiya_status = 0
								im.putong_syl = true
								im.gaoji_syl = false
							}

						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			get_shouyi_log() {
				var lang = this.$i18n.locale
				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}

				var im = this
				axios({
						method: 'post',
						url: domain.publicUrl + "/api/api/shouyi_log",
						data: {
							address: address,
							type: newtype,
							lang: lang
						},
					})
					.then(function(response) {
						im.shouyi_data = response.data.data

					})
					.catch(function(error) {
						console.log(error);
					});



			},

			get_user_level() {
				var lang = this.$i18n.locale
				var address = sessionStorage.getItem('address');

				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}

				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/user_level?address=" + address + "&type=" + newtype,
					})
					.then(function(response) {
						im.user_level = response.data.data

					})
					.catch(function(error) {
						console.log(error);
					});



			},
			get_yue() {
				var lang = this.$i18n.locale
				var name = "English"
				if (lang == 'zh') {
					name = '简体中文'
				} else if (lang == 'fa') {
					name = '繁体中文'
				} else if (lang == 'en') {
					name = 'English'
				} else if (lang == 'po') {
					name = 'Português'
				} else if (lang == 'al') {
					name = 'عربي'
				} else if (lang == 'de') {
					name = 'Deutsch'
				} else if (lang == 'xi') {
					name = 'español'
				} else if (lang == 'yi') {
					name = 'Italiano'
				} else if (lang == 'el') {
					name = 'Русский'
				} else if (lang == 'ja') {
					name = '日本語'
				} else if (lang == 'tu') {
					name = 'Türkçe'
				}
				this.xz_lang = name
				var address = sessionStorage.getItem("address");
				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {
					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}


				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_yue?type=" + newtype + "&address=" + address
					})
					.then(function(response) {
						console.log(response.data.data)
						im.user_data = response.data.data

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			fn() {
				var lang_type = sessionStorage.getItem("lang_type");
				var name = "English"
				if(!lang_type){
					name = "English"
				}else{
					if (lang_type == 'zh') {
						name = '简体中文'
					} else if (lang_type == 'fa') {
						name = '繁体中文'
					} else if (lang_type == 'en') {
						name = 'English'
					} else if (lang_type == 'po') {
						name = 'Português'
					} else if (lang_type == 'al') {
						name = 'عربي'
					} else if (lang_type == 'de') {
						name = 'Deutsch'
					} else if (lang_type == 'xi') {
						name = 'español'
					} else if (lang_type == 'yi') {
						name = 'Italiano'
					} else if (lang_type == 'el') {
						name = 'Русский'
					} else if (lang_type == 'ja') {
						name = '日本語'
					} else if (lang_type == 'tu') {
						name = 'Türkçe'
					}
				}
				
				
				this.xz_lang = name
			},

		
		},
		mounted: function() { //自动触发写入的函数
			this.wakeUpWallet();
			this.level_list();
			this.level_list_gaoji();
			this.get_zhiya_status();
			this.get_shouyi_log();
			this.get_user_level();
			this.get_yue();
			this.fn();
		}
	}
</script>

<style>
</style>